import React from 'react';
import styled from 'styled-components';
import { Formik, FormikProps, Form } from 'formik';
import { AppColors } from 'helpers';
import { SelectDropdown, SelectItem } from 'modules/common/vendors/Select';
import { IUser } from 'models/User';
import { HorizontalView, VerticalView } from 'modules/common/vendors/Wrapper';
import { useTranslationText } from 'locale';
import { useAppSetting } from 'helpers/useAppSetting';
import { ImagePicker } from 'modules/common/components/ImagePicker/ImagePicker';
import { InputProps, Input } from 'modules/common/vendors/Input';
import { PrimaryButton } from 'modules/common/components/Button/PrimaryButton';
import { ButtonOutline } from '../../../../common/components/Button/ButtonOutline';
import { updateUserValidatorSchema } from '../../validator/index';

const FormEditWrapper = styled.div`
  width: 100%;
  padding-top: 20px;
`;

const i18key = 'userDetails';

export const InputField = (props: InputProps) => {
  return (
    <Input
      fontSize={props.fontSize || '30px'}
      background={'transparent'}
      style={{ color: AppColors.WHITE, background: 'transparent', width: '100%', minWidth: '320px' }}
      {...props}
    />
  );
};

interface UserUpdateFormProps {
  user?: IUser;
  onSave?: (user: IUser) => void;
  onChangePassword: () => void;
}
export const UserInformation = (props: UserUpdateFormProps) => {
  const { getTypes } = useTranslationText();
  const { appSize, appLayout } = useAppSetting();
  const ref = React.useRef<FormikProps<IUser | any>>(null);

  const yesNoTypes: SelectItem[] = getTypes('yesNoTypes');
  const statusTypes: SelectItem[] = getTypes('status');

  React.useEffect(() => {
    if (props.user && ref && ref.current) {
      ref.current.setValues({ ...props.user });
    }
  }, [props.user]);

  return (
    <FormEditWrapper>
      <Formik
        innerRef={ref}
        enableReinitialize={true}
        initialValues={props.user || ({} as IUser)}
        validationSchema={updateUserValidatorSchema}
        onSubmit={(values: IUser) => {
          props.onSave && props.onSave(values);
        }}
      >
        {({ values, errors, submitCount, handleChange, setFieldValue }) => {
          return (
            <Form>
              <VerticalView width={'100%'} alignContent={'centerLeft'}>
                <VerticalView fullWidth alignContent={'centerLeft'}>
                  <ImagePicker
                    maxImageWidth={512}
                    label={`${i18key}.avatar`}
                    ratios={['1x1']}
                    width={'230px'}
                    height={'230px'}
                    value={values.avatar}
                    onSelect={(url) => setFieldValue('avatar', url)}
                  />
                </VerticalView>

                <VerticalView minWidth={'320px'} fullWidth alignContent={'centerLeft'} marginTop={'20px'}>
                  <Input
                    label={`${i18key}.email`}
                    isPreview
                    placeholder={`${i18key}.email`}
                    name={'email'}
                    fontSize={appSize.md}
                    value={values.email}
                    onChange={handleChange}
                  />
                  <HorizontalView fullWidth paddingTop={'20px'}>
                    <Input
                      id={'name'}
                      name={'name'}
                      fontSize={appSize.md}
                      value={values.name}
                      label={`${i18key}.name`}
                      placeholder={`${i18key}.name`}
                      error={submitCount ? errors.name : undefined}
                      onChange={handleChange}
                    />
                  </HorizontalView>

                  <HorizontalView fullWidth paddingTop={'20px'}>
                    <SelectDropdown
                      width={'100%'}
                      size={appSize.md}
                      direction={'column'}
                      id={'isLocked'}
                      label={`${i18key}.isLocked`}
                      dataType={'list'}
                      value={values.isLocked || false}
                      style={{ minWidth: '150px' }}
                      options={yesNoTypes}
                      onChange={(value) => {
                        setFieldValue('isLocked', value);
                      }}
                    />
                  </HorizontalView>
                  <HorizontalView fullWidth paddingTop={'20px'}>
                    <SelectDropdown
                      width={'100%'}
                      size={appSize.md}
                      direction={'column'}
                      id={'isVerified'}
                      label={`${i18key}.status`}
                      dataType={'list'}
                      value={values.isVerified || false}
                      style={{ minWidth: '150px' }}
                      options={statusTypes}
                      onChange={(value) => {
                        setFieldValue('isVerified', value);
                      }}
                    />
                  </HorizontalView>
                </VerticalView>
              </VerticalView>
            </Form>
          );
        }}
      </Formik>
      <HorizontalView width={'100%'} marginTop={'40px'} alignContent={'centerRight'}>
        <ButtonOutline
          width={appLayout.isMobile ? '100%' : 'auto'}
          icon={'key'}
          title={`${i18key}.changePass`}
          marginRight={appLayout.isMobile ? '0px' : '20px'}
          onClick={props.onChangePassword}
        />

        <PrimaryButton
          icon={'save'}
          marginTop={appLayout.isMobile ? '20px' : '0px'}
          width={appLayout.isMobile ? '100%' : 'auto'}
          title={`${i18key}.save`}
          onClick={() => {
            if (ref && ref.current) {
              ref.current.handleSubmit();
            }
          }}
        />
      </HorizontalView>
    </FormEditWrapper>
  );
};
